import { A3Sheet } from "../../icons/index.js";
import {
  MySolvesParamsSchema,
  defaultMySolvesParams,
  type MySolvesParams,
} from "@playbookai/widget-schemas";
import { registerWidget } from "../registry.js";
import type { SqlWidgetDef } from "../types.js";
import { MySolvesWidget } from "./Component.js";
import type { MySolvesView } from "./types.js";

export const mySolvesDef: SqlWidgetDef<MySolvesParams, MySolvesView> = {
  kind: "mySolves",
  label: "My SOLVEs",
  modes: ["dashboard"],
  singleton: true,
  defaultSize: { w: 480, h: 320 },
  defaultParams: defaultMySolvesParams,
  Component: MySolvesWidget,
  storage: "sql",
  schema: MySolvesParamsSchema,
  accent: "cyan",
  icon: A3Sheet,
  subtitle: "Your recent open problem-solving work",
  defaultRoster: false,
  category: "single",
  layout: { col: 0, row: 1, width: 480, height: 320 },
  dashboard: {
    icon: A3Sheet,
    defaultWidth: "wide",
    category: "Personal",
  },
};

registerWidget(mySolvesDef);
